export default __webpack_public_path__ + "static/seald-icon-41b45ca939cb9f9f64aee867f3d4671a.svg";